import { Box } from '@chakra-ui/react';
import { useSelector, useDispatch } from 'react-redux';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';

import { getFormValues } from 'redux/DataImportSlice';
import { fetchModelTime } from 'redux/IndicatorPageSlice';

import { StepHeading } from '../actionStepUi';

import Rows from './TimePeriod/Rows';
import Columns from './TimePeriod/Columns';

interface Properties {
  setHelpModalSeleceted?: any;
}

const DataStepsTwo = ({ setHelpModalSeleceted }: Properties) => {
  const dispatch: any = useDispatch();
  const { modelId } = useParams();

  const getFormValue = useSelector(getFormValues);
  useEffect(() => {
    dispatch(fetchModelTime(Number(modelId)));
  }, []);
  return (
    <Box w='100%'>
      <StepHeading
        title='Select time period'
        subtitle='Point to where the periods sit in your file.'
      />
      {getFormValue?.selectedTimePeriod === 'row' ? (
        <Rows setHelpModalSeleceted={setHelpModalSeleceted} getFormValue={getFormValue} />
      ) : (
        <Columns setHelpModalSeleceted={setHelpModalSeleceted} getFormValue={getFormValue} />
      )}
    </Box>
  );
};

export default DataStepsTwo;
